import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UserManagementService } from 'src/app/Service/user-management.service';

@Component({
  selector: 'app-delete-harvest-unit',
  templateUrl: './delete-harvest-unit.component.html',
  styleUrls: ['./delete-harvest-unit.component.scss']
})
export class DeleteHarvestUnitComponent implements OnInit {
  deteCropHarvestForm:FormGroup;

  constructor(
    public dialogRef: MatDialogRef<DeleteHarvestUnitComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public _userService: UserManagementService,
    public toastr: ToastrService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.formInIt();
  }

  formInIt(){
    this.deteCropHarvestForm = this.fb.group({
      Remark: ['', [Validators.required]],
    });
  }

  onSubmit(value: any) {
    if (this.deteCropHarvestForm.valid) {
      var deleteItems = {
        result: value,
        remark: this.deteCropHarvestForm.value.Remark,
      };

      this.dialogRef.close(deleteItems);
    } else {
      alert('Please Enter the valid remark!');
    }
  }
  
  onNoClicks(value): void {
    this.dialogRef.close(value);
  }

  get f() {
    return this.deteCropHarvestForm.controls;
  }
}
